<template>
  <div>
    <el-table
      height="400px"
      border
      key="clientVal"
      ref="clientFollowRef"
      :data="clientFollowData.followInfo"
      @select="handleSelectionChangeFollow"
      :header-cell-style="{
        'text-align': 'center',
        background: '#edf3fe',
        color: '#0d6fb8',
      }"
      :cell-style="{ 'text-align': 'center' }"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
        prop="followContent"
        label="跟进内容"
        show-overflow-tooltip=""
      ></el-table-column>
      <el-table-column prop="intentionLevel" label="意向级别">
        <template slot-scope="{ row }">
          {{ getCurrentStage(row.intentionLevel, "intentionLevel") }}
        </template>
      </el-table-column>
      <el-table-column prop="workers" label="跟进人">
        <template slot-scope="{ row }">
          <!-- {{ row.workers }} -->
          {{ getWorkersVal(row.workers) }}
        </template>
      </el-table-column>
      <el-table-column prop="currentStage" label="跟进阶段">
        <template slot-scope="{ row }">
          {{ getCurrentStage(row.currentStage, "currentStage") }}
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleNext">下 一 步</el-button>
      <el-button @click="visibleClientFollow = false">取 消</el-button>
    </div>
  </div>
</template>

<script>
import { clientFollowDetailGet } from "@/api/PotentialCustomers";
export default {
  props: {
    userId: [Number, String],
  },
  data() {
    return {
      clientFollowData: {},
    };
  },
  methods: {
    getClientFollowDetail() {
      console.log("怎么没见");
      clientFollowDetailGet({
        type: 1,
        userId: this.userId,
      }).then((res) => {
        if (res.code === 20000) {
          this.clientFollowData = res.data;
          if (res.data.followInfo && res.data.followInfo.length) {
            this.visibleClientFollow = true;
          } else {
            this.getFollowInfoAxios();
            if (this.currentBthState == 1) {
              this.visibleFollow = true;
            } else if (this.currentBthState == 2) {
              this.visibleFollowArrange = true;
            }
          }
        }
      });
    },
    // 获取跟进安排详情信息
    async getFollowInfoAxios() {
      let params = {
        type: 1,
        userId: this.userId,
        masterId: this.masterId,
      };
      const res = await adminFollowInfoGet(params);
      console.log(res, "res1111111111值");
      if (res.code == 20000) {
        this.clientAllData = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/user_child/components/ClientFollow.vue